import { render, staticRenderFns } from "./ListCart.vue?vue&type=template&id=5aa28c7f&scoped=true"
import script from "./ListCart.vue?vue&type=script&lang=ts"
export * from "./ListCart.vue?vue&type=script&lang=ts"
import style0 from "./ListCart.vue?vue&type=style&index=0&id=5aa28c7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa28c7f",
  null
  
)

export default component.exports